package com.macrofocus.eflux.components

import com.macrofocus.common.json.getArray
import com.macrofocus.common.json.getObject
import com.macrofocus.common.json.getString
import com.macrofocus.common.json.length
import com.macrofocus.eflux.network.risk.RiskComponent
import com.macrofocus.eflux.ui.PaletteType
import com.macrofocus.eflux.ui.data.RiskTypeChip
import i18next.useTranslation
import mui.material.Stack
import mui.material.StackDirection
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.responsive
import react.FC
import react.PropsWithChildren
import web.cssom.JustifyContent

external interface RiskComponentInfoProps : PropsWithChildren {
    var riskComponent: RiskComponent
}

val RiskComponentInfo = FC<RiskComponentInfoProps> { props ->
    val theme = useTheme<Theme>()
    val paletteType = if (theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light
    val (t, _) = useTranslation()

    val allRiskTypes = mutableListOf<String>()
    props.riskComponent.lines.forEach { line ->
        for(l in 0 until line.details!!.length()) {
            val a = line.details?.getObject(l)?.getArray("details")
            if(a != null) {
                for(i in 0 until a.length()) {
                    val b = a.getObject(i)?.getString("risk_type")
                    if(b != null) {
                        if(!allRiskTypes.contains(b)) {
                            allRiskTypes.add(b)
                        }
                    }
                }
            }
        }
    }

//    val details = props.riskComponent.lines.map { line ->
//
//
//        val array = Array<JsonArray?>(line.details!!.length()) { i ->
//            line.details!!.get<JsonObject>(i).getArray("details")
//        }
//        val x = array.map { details -> details.getObject()
//        }
//
//        val list = array.toList().filterNotNull()
//        list.flatten() as List<JsonObject>
//        array.flatMap { it.toList() }.filterIsInstance<JsonObject>().map {  }
////        line.details?.get<JsonArray>("details")
//    }
//    val x = details.map { detail ->
//        if(detail != null) {
//            Array<String?>(detail.length()) { i ->
//                detail.get<JsonObject>(i).getString("risk_type")
//            }
//        } else null
//    }
    val riskTypes = allRiskTypes.distinct()

    Stack {
        direction = responsive(StackDirection.row)
        asDynamic().justifyContent = JustifyContent.center

        for (riskType in riskTypes) {
            RiskTypeChip {
                this.riskType = riskType
            }
        }
    }
}
